module.exports = __webpack_public_path__ + "media/photo/technology_features2-8eb6df49.png";